// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__z9hi6","title":"Header_title__3vuWh","left":"Header_left__H94x7","clinicName":"Header_clinicName__2hixK"};